import { Instance, types } from 'mobx-state-tree';

export const FeatureModel = types.model('FeatureModel', {
  value: types.maybeNull(types.number),
  importance: types.maybeNull(types.number),
  maxValue: types.maybeNull(types.number),
  minValue: types.maybeNull(types.number),
  feature: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  color: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  descriptionForSurvey: types.maybeNull(types.string),
  outputSentence: types.maybeNull(types.string),
  freeTextVal: types.maybeNull(types.string),
  logo: types.maybeNull(types.string),
  answerValues: types.maybeNull(types.array(types.string)),
  lowIsBetter: types.maybeNull(types.boolean),
});

export type IFeature = Instance<typeof FeatureModel>;
